import { useState } from 'react'
const SLOW_CONNECTIONS = /* @__PURE__ */ new Set(['slow-2g', '2g', '3g'])
export function networkAllowsPreload() {
  if (typeof navigator === 'undefined') return true
  const connection = navigator.connection
  if (!connection) return true
  if (connection.saveData) return false
  if (connection.effectiveType && SLOW_CONNECTIONS.has(connection.effectiveType)) return false
  return true
}
export function useNetworkAllowsPreload() {
  const [allowed] = useState(networkAllowsPreload)
  return allowed
}
